import { createContext, useContext, useState } from "react";

const MicrogridContext = createContext();

export const MicrogridProvider = ({ children }) => {
  const [selectedDesign, setSelectedDesign] = useState(null);
  return (
    <MicrogridContext.Provider value={{ selectedDesign, setSelectedDesign }}>
      {children}
    </MicrogridContext.Provider>
  );
};

export const useMicrogrid = () => useContext(MicrogridContext);
